import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="HTML5">
                <h1>Hire Best HTML5 Developers Quickly in USA</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  Achieve your business objectives faster with TekRevol’s
                  dedicated HTML5 app development. We help businesses build
                  robust digital solutions for internal operational and diverse
                  customer segments, including web, apps, and SaaS.
                </p>
                <ul>
                  <li>Build robust digital solutions</li>
                  <li>Achieve business objectives</li>
                  <li>Cater diverse customer segments</li>
                  <li>Internal operational solutions</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
